define(
({
  "select_shipping_method": "배송 방법 선택"
})
);
